"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseModel_1 = require("./BaseModel");
var ConsultationRequest;
(function (ConsultationRequest) {
    var Create = (function (_super) {
        __extends(Create, _super);
        function Create() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.bookId = undefined;
            _this.name = undefined;
            _this.description = undefined;
            _this.phone = undefined;
            _this.email = undefined;
            _this.status = undefined;
            return _this;
        }
        return Create;
    }(BaseModel_1["default"]));
    ConsultationRequest.Create = Create;
    var Update = (function (_super) {
        __extends(Update, _super);
        function Update() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.status = undefined;
            _this.observations = undefined;
            return _this;
        }
        return Update;
    }(BaseModel_1["default"]));
    ConsultationRequest.Update = Update;
})(ConsultationRequest = exports.ConsultationRequest || (exports.ConsultationRequest = {}));
var ConsultationResponse;
(function (ConsultationResponse) {
    var Consultation = (function (_super) {
        __extends(Consultation, _super);
        function Consultation() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.booksId = undefined;
            _this.Book = undefined;
            _this.name = undefined;
            _this.phone = undefined;
            _this.email = undefined;
            _this.description = undefined;
            _this.updatedAt = undefined;
            _this.status = undefined;
            _this.observations = undefined;
            return _this;
        }
        return Consultation;
    }(BaseModel_1["default"]));
    ConsultationResponse.Consultation = Consultation;
    var All = (function (_super) {
        __extends(All, _super);
        function All(objects, length, offset, pagination) {
            if (length === void 0) { length = 0; }
            if (offset === void 0) { offset = 0; }
            if (pagination === void 0) { pagination = 100; }
            var _this = _super.call(this) || this;
            _this.objects = undefined;
            _this.length = 0;
            _this.offset = 0;
            _this.pagination = 100;
            _this.objects = objects;
            _this.length = length;
            _this.offset = offset;
            _this.pagination = pagination;
            return _this;
        }
        return All;
    }(BaseModel_1["default"]));
    ConsultationResponse.All = All;
})(ConsultationResponse = exports.ConsultationResponse || (exports.ConsultationResponse = {}));



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/consultation.js
// module id = ../model/dist/models/consultation.js
// module chunks = main